import { InjectionToken } from '@angular/core';
import { Locale } from 'date-fns';

export interface AppDateFormats {
  parse: { dateInput: any };
  display: {
    dateInput: any;
    monthYearLabel: any;
    dateA11yLabel: any;
    monthYearA11yLabel: any;
  };
}

export const APP_DATE_FORMATS = new InjectionToken<AppDateFormats>(
  'app-date-formats'
);

export const APP_DATE_LOCALE = new InjectionToken<Locale>('app-date-locale');
